(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("colorutil", [], factory);
	else if(typeof exports === 'object')
		exports["colorutil"] = factory();
	else
		root["colorutil"] = factory();
})(window, function() {
return 